<template>
  <div>
    <el-pagination
      background
      @size-change="handleSize"
      @current-change="handleCurent"
      :current-page="currentPage"
      :page-sizes="Pagesize"
      :page-size="currentSize"
      :layout="layout"
      :total="dataTotal"
      :pager-count="pagecount"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "paging",
  props: {
    currentPage: {
      type: Number
    },
    currentSize: {
      type: Number,
      default: 30
    },
    Pagesize: {
      type: Array,
      default() {
        return [30, 50, 100];
      }
    },
    dataTotal: {
      type: Number,
      default: 0
    },
    layout: {
      type: String,
      default: "total, sizes, prev, pager, next, jumper"
    },
    pagecount: {
      type: Number,
      default: 7
    },
    needBackTop: {
      type: Boolean,
      default: true
    },
    target: {
      type: String,
      default: ".dataBox"
    }
  },
  methods: {
    handleSize(size) {
      this.$emit("handlePageSize", size);
    },
    handleCurent(current) {
      this.$emit("handlePageCurent", current);
    }
  }
};
</script>

<style lang="less" scoped="scoped">
.el-pagination {
  font-size: 16px;
  /deep/span,
  /deep/input {
    font-size: 16px !important;
  }
}
.el-pagination__sizes .el-input .el-input__inner {
  font-size: 16px !important;
}

</style>
<style>
.el-select-dropdown__item {
  font-size: 16px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/paging/paging.vue